import { truncateString } from "@/utils/functions/functions";

interface Props {
  name: string;
  isEvent?: boolean;
}

const ProductName: React.FC<Props> = ({ name, isEvent }) => {
  return (
    <h3 className={`product-name ${isEvent ? "" : "event"}`} dir="auto">
      {truncateString(name, 190)}
    </h3>
  );
};

export default ProductName;
